import React from 'react'
import * as SC from './style'

const Header = () => {
  return (
    <SC.HeaderWrapper>Auxiliares</SC.HeaderWrapper>
  )
}

export default Header